import { Component, Inject, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { AsyncDataService } from '../../services/async-data.service';
import { SwitchPostService } from './switch-post.service';
import { MatDialog } from '@angular/material/dialog';
import { LogoutComponent } from '../../../digigov/dg_core/logout/logout.component';
import { AppInitService } from '../../services/app-init.service';
@Component({
  selector: 'app-switch-post',
  templateUrl: './switch-post.component.html',
  styleUrls: ['./switch-post.component.scss'],
})
export class SwitchPostComponent implements OnInit {
  posts = [];
  origin: string;
  selectedPosts = null;
  selectedDefault = null;
  checkValue;
  isDefPost = false;
  isSelPost = false;
  isLogDisp = false;
  allPost = {
    postName: 'All ',
    postId: -1, //random post id
  };
  apiSubject = new Subject<Number>();

  //changes for geoLocBasedPostSelection by Arth --start
  countries = [];
  countryLabel = null;
  stateLabel = null;
  states = {};
  switchPostForm: FormGroup;
  sortedStates: any;
  selectedCountryState: any;
  //changes for geoLocBasedPostSelection by Arth --end

  constructor(
    private dialogRef: MatDialogRef<SwitchPostComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public switchPostService: SwitchPostService,
    public route: ActivatedRoute,
    private router: Router,
    public appInitService: AppInitService
  ) {}

  ngOnInit(): void {
    //changes for geoLocBasedPostSelection by Arth --start
    if (this.switchPostService?.useGeoLocBasedPostSelection) {
      this.switchPostForm = new FormGroup({
        selectedCountry: new FormControl(null, [Validators.required]),
        selectedState: new FormControl(null, [Validators.required]),
      });
      this.switchPostService
        ?.getGeoLocDtlsForLoggedInUser()
        ?.subscribe((res) => {
          let tempData = res?.data;
          tempData?.forEach((loc: any) => {
            loc?.forEach((ele: any, index) => {
              if (index == 0) {
                if (!this.countryLabel) {
                  this.countryLabel =
                    ele?.addressFieldVOList[0]?.addressFieldKey;
                }
                if (
                  this.countries?.indexOf(ele?.geoLocDtlVO?.geoLocName) === -1
                ) {
                  this.countries.push(ele?.geoLocDtlVO?.geoLocName);
                  this.states = {
                    ...this.states,
                    [ele?.geoLocDtlVO?.geoLocName]: [],
                  };
                }
              } else if (index != 0) {
                if (!this.stateLabel) {
                  this.stateLabel = ele?.addressFieldVOList[0]?.addressFieldKey;
                }
                if (
                  this.states[loc[0]?.geoLocDtlVO?.geoLocName]?.findIndex(
                    (x) => x?.stateName === ele?.geoLocDtlVO?.geoLocName
                  ) === -1
                ) {
                  this.states[loc[0]?.geoLocDtlVO?.geoLocName].push({
                    stateName: ele?.geoLocDtlVO?.geoLocName,
                    postId: [ele?.postId],
                  });
                } else {
                  this.states[loc[0]?.geoLocDtlVO?.geoLocName]?.forEach((e) => {
                    if (e.stateName === ele?.geoLocDtlVO?.geoLocName) {
                      e.postId.push(ele?.postId);
                    }
                  });
                }
              }
            });
          });
          this.countries = this.countries.sort();
        });
    } //changes for geoLocBasedPostSelection by Arth --end
    else {
      this.origin = this.data?.origin;
      if (this.switchPostService?.currentUserSwitchPost?.allPost) {
        this.posts = JSON.parse(
          JSON.stringify(this.switchPostService?.currentUserSwitchPost?.allPost)
        );
        console.log("Post Details")
        console.log(this.posts)
        // ADDED BY CFMS
        let arr=[];
        for(let i=0;i<this.posts.length;i++)
        {
          if(this.posts[i]["additionalOrgParams"])
          {
            if(this.posts[i]["additionalOrgParams"].isAGVerified==true &&
            this.posts[i]["additionalOrgParams"].migratedOrg=="N")
            {
              arr.push(this.posts[i]);
            }
            if(!this.posts[i]["additionalOrgParams"].migratedOrg)
            {
              arr.push(this.posts[i]);
            }
          }

          if(!this.posts[i]["additionalOrgParams"])
          {
            arr.push(this.posts[i]);
          }

          if(this.posts[i]["additionalOrgParams"].migratedOrg=="Y")
            {
              arr.push(this.posts[i]);
            }
        }
        // this.posts = res?.allPost;
        this.posts=arr;
        this.setPostsData();
      } else {
        this.getSwitchDtls();
      }
    }
  }
  getSwitchDtls(): void {
    this.switchPostService.getSwitchPostDtls().subscribe(
      (res) => {
        this.posts = JSON.parse(JSON.stringify(res?.allPost));
        this.setPostsData();
      },
      (error) => {}
    );
  }

  setPostsData() {
   
    // this.posts.splice(0,0,this.allPost)
    if (this.switchPostService?.currentUserSwitchPost?.defaultPostId) {
      this.setDefaultPostData(
        this.switchPostService?.currentUserSwitchPost?.defaultPostId
      );
    }
    this.checkValue =
      this.switchPostService.currentUserSwitchPost?.dialogOpenFlag === 1;
  }

  setDefaultPostData(restemp) {
    if(restemp==-1)
    {
      this.selectedDefault=0;
    }
    else
    {
      this.posts.forEach((element, index) => {
        if (element.postId == restemp) {
          this.selectedDefault = index;
        }
      });
    }
   
    if (this.switchPostService?.currentUserSwitchPost?.postDetailsVO) {
      this.setSelectPostData(
        this.switchPostService?.currentUserSwitchPost?.postDetailsVO
      );
    }
  }

  setSelectPostData(restemp) {
    if (restemp == 'Default') {
      this.selectedPosts = this.posts[this.selectedDefault];
     
      this.isSelPost = true;
    } else if (restemp == 'All Selected') {
      this.selectedPosts = this.posts[0];
    } else {
      this.posts.forEach((element, index) => {
        if (element.postId == restemp.POST_Id) {
          this.selectedPosts = element;
        }
      });
    }
  }

  selPostChange(event) {
    this.isSelPost = true;
  }
  onDefaultClick(index) {
    if (this.selectedDefault !== index) {
      this.selectedDefault = index;
      this.isDefPost = true;
    }
  }
  checkChange(event) {
    this.isLogDisp = true;
  }
  onSwitch(flag: boolean = false) {
    this.apiSubject.subscribe((res) => {
      localStorage.setItem("justLogin","false")
      if (res == 1) {
        this.setLoginDisp();
      } else if (res == 2) {
        this.setSelectedPost();
      }
    });
    this.setDefault(
      flag
        ? this.selectedPosts?.postId
        : this.posts[this.selectedDefault].postId
    );
  }

  setDefault(postId) {
    if (this.isDefPost) {
      this.switchPostService.selectDefaultPost(postId).subscribe(
        (res) => {
          this.apiSubject.next(1);
        },
        (error) => {
          this.apiSubject.next(1);
        }
      );
    } else {
      this.apiSubject.next(1);
    }
  }

  setLoginDisp() {
    if (this.isLogDisp) {
      let checkBody;

      if (this.checkValue == true) {
        checkBody = 1;
      } else {
        checkBody = 0;
      }
      this.switchPostService.setLoginDisp(checkBody).subscribe(
        (res) => {
          this.apiSubject.next(2);
        },
        (error) => {
          this.apiSubject.next(2);
        }
      );
    } else {
      this.apiSubject.next(2);
    }
  }

  setSelectedPost() {
    if (this.isSelPost) {
      let body = [];
      body.push(this.selectedPosts);
      if (this.selectedPosts == this.allPost) {
        body = this.posts.slice(1, this.posts.length + 1);
      }
      this.switchPostService.selectPosts(body).subscribe(
        // (res) => {
        //   window.location.reload();
        // },
        () => {
          this.router
            .navigateByUrl(this.appInitService.appConfig.afterLoginLandingUrl)
            .then(() => {
              window.location.reload();
            });
        },
        (error) => {}
      );
    }
    this.dialogRef?.close();
  }

  //changes for geoLocBasedPostSelection by Arth --start
  onCountryChange(event): void {
    if (!event) {
      this.switchPostForm?.controls?.selectedState?.setValue(null);
    } else {
      this.selectedCountryState = this.states?.[
        this.switchPostForm?.controls?.selectedCountry?.value
      ];
      this.selectedCountryState.sort(function (a, b) {
        if (a.stateName < b.stateName) {
          return -1;
        }
        if (a.stateName > b.stateName) {
          return 1;
        }
        return 0;
      });
    }
  }

  onStateChange(event): void {
    this.selectedPosts = { postId: event?.postId[0] };
    this.isLogDisp = true;
    this.checkValue = false;
    this.isSelPost = true;
    this.isDefPost = true;
  }

  logout(): void {
    // console.log("logout clicked");

    // this.authenticationService.logout();
    this.dialog.open(LogoutComponent, { disableClose: true });
  }
  //changes for geoLocBasedPostSelection by Arth --end
}
